export default "__VITE_ASSET__72EZ7Yfu__"